module.exports = __webpack_public_path__ + "res/ic_menu_settings.403af5c3b9753966ab2aa7b0644f0b2c.png";